export const FETCH_EMPLOYEE_FLEXI_PARTNER_DETAILS = 'FETCH_EMPLOYEE_FLEXI_PARTNER_DETAILS';
export const SYNC_EMPLOYEE_FLEXI_PARTNER_DETAILS = 'SYNC_EMPLOYEE_FLEXI_PARTNER_DETAILS';